import React from 'react';

interface OcultableProps {
    children: React.ReactNode,
    enabled: boolean
}

export const Ocultable = ({ enabled, children }: OcultableProps) => (
    <>
        { enabled ? <></> : children }
    </>
)